/**
 * GlitchText — RGB-split glitch effect on a single word.
 * Renders the word plus two duplicates via ::before / ::after (see .glitch in index.css).
 */
export default function GlitchText({ text, className = "", as: Tag = "span" }) {
  return (
    <Tag
      className={`glitch ${className}`}
      data-text={text}
      data-testid="glitch-text"
    >
      {text}
    </Tag>
  );
}
